import React from "react";
import { motion } from "framer-motion";

const Preloader = ({ logoUrl, siteName }) => {
  const loaderStyle = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
    backgroundColor: "#ffffff",
  };

  const imageStyle = {
    width: "120px",
    height: "120px",
    objectFit: "contain",
  };

  const resolvedLogo =
    logoUrl ||
    window.__SITE_ICON__ ||
    window.__SITE_LOGO__ ||
    "/images/favicon.png";

  return (
    <div style={loaderStyle}>
      <motion.img
        src={resolvedLogo}
        alt={siteName || "Loading"}
        style={imageStyle}
        animate={{ y: [0, -20, 0] }} // Bounce effect
        transition={{ duration: 1.5, repeat: Infinity, ease: "easeInOut" }}
      />
    </div>
  );
};

export default Preloader;
